export enum ToolTypeEnum {
  CAAS = 'capital_asset',
  VR = 'variance_analysis',
  AR = 'aged_ar_analysis',
  IR = 'investment_schedule',
  GL = 'general_ledger',
  LAS = 'loan_amortization',
  HST = 'hst_analysis',
  BR = 'bank_reconciliation',
  BS_TO_TB = 'bank_statements_to_tb',
  PA = 'payroll_analysis',
  RR = 'rent_reasonability',
  CT = 'covenant_testing',
  IRR = 'interest_reasonability'
}
